"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsV2 = void 0;
var helpers_1 = require("../helpers");
var EventsV2 = /** @class */ (function () {
    function EventsV2() {
        this.observers = {};
    }
    EventsV2.prototype.on = function (event, fn) {
        var key = helpers_1.makeid(6);
        if (!this.observers[event]) {
            this.observers[event] = [key, fn];
        }
        else {
            this.observers[event].push([key, fn]);
        }
        return key;
    };
    EventsV2.prototype.off = function (event, key) {
        try {
            this.observers[event] = this.observers[event].filter(function (_a) {
                var _key = _a[0];
                return _key !== key;
            });
        }
        catch (e) {
            console.log('Error off', e);
            return;
        }
    };
    EventsV2.prototype.emit = function (event, data) {
        var events = this.observers[event];
        if (!events)
            return;
        try {
            events.map(function (_a) {
                var key = _a[0], fn = _a[1];
                try {
                    fn(data);
                }
                catch (e) {
                    return;
                }
            });
        }
        catch (e) {
            console.log('Event errors', event);
        }
    };
    return EventsV2;
}());
exports.EventsV2 = EventsV2;
